import { getInitialState, updateState } from "@/utils/helpers/StoreUtil";
import DataProvider from "@/utils/helpers/DataProvider";

import { IVuexState } from "@/models/interfaces/store";
import { AxiosError } from "axios";

import { State as RootState } from "@/store";
import { ActionTree, MutationTree, Module } from "vuex";
import { IGrammarVideo } from "@/models/interfaces/grammar-to-go";

export interface State {
  videos: IVuexState<Array<IGrammarVideo[]>>;
  video: IVuexState<any>;
}

export const actions: ActionTree<State, RootState> = {
  async fetchVideos({ commit }) {
    commit("setVideos");

    return DataProvider.get<{ data: IGrammarVideo[] }>("grammarToGoVideos")
      .then(response => {
        commit("setVideos", response.data.data);
        return response.data.data;
      })
      .catch((error: AxiosError) => {
        commit("setVideos", error);
        return error;
      });
  },

  async fetchVideo({ commit }, id: string) {
    commit("setVideo");

    return DataProvider.get<{ data: IGrammarVideo }>(`grammarToGoVideos/${id}`)
      .then(response => {
        commit("setVideo", response.data.data);
        return response.data.data;
      })
      .catch((error: AxiosError) => {
        commit("setVideo", error);
        return error;
      });
  }
};

export const mutations: MutationTree<State> = {
  setVideos(state, data?: Array<IGrammarVideo[]> | AxiosError) {
    state.videos = updateState(state.videos, data);
  },
  setVideo(state, data?: IGrammarVideo | AxiosError) {
    state.video = updateState(state.video, data);
  }
};

const store: Module<State, RootState> = {
  namespaced: true,
  state: {
    video: getInitialState(),
    videos: getInitialState()
  },
  mutations,
  actions
};

export default store;
